import { render } from "./D_FollowList.vue?vue&type=template&id=562e23bc&scoped=true"
import script from "./D_FollowList.vue?vue&type=script&lang=js"
export * from "./D_FollowList.vue?vue&type=script&lang=js"

import "./D_FollowList.vue?vue&type=style&index=0&id=562e23bc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\SAEUM\\Desktop\\teampl-project\\github\\unibuzzy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-562e23bc"]])

export default __exports__